import animejs from 'animejs';
import {FILTER_SELECTED_EVENT} from "../constants/events";

export class FiltersController {
    constructor($root, $items = null) {
        this.$root = $root;
        this.$filters = this.$root.querySelectorAll('[data-filter]');
        this.$items = $items;

        this.init();
    }

    init() {
        this.$filters.forEach(($filter) => {
            $filter.addEventListener('click', () => {
                this.setFilter($filter);
            });
        });

        if (this.$items && this.$items.length) {
            this.$root.addEventListener(FILTER_SELECTED_EVENT, (e) => {
                this.$items.forEach(($item) => {
                    if (e.detail === 'all' || $item.dataset.category === 'all' || $item.dataset.category === e.detail) {
                        $item.classList.remove('-hidden');
                    } else {
                        $item.classList.add('-hidden');
                    }

                    animejs({
                        targets: $item,
                        delay: 10,
                        opacity: {
                            value: [0, 1],
                            duration: 300
                        },
                        scale: {
                            value: [0.9, 1],
                            duration: 200
                        },
                        easing: 'easeInOutCubic'
                    });
                });
            });
        }
    }

    setFilter($filter) {
        this.$filters.forEach(($filter) => {
            $filter.classList.remove('-active');
        });
        $filter.classList.add('-active');
        this.$root.dispatchEvent(new CustomEvent(FILTER_SELECTED_EVENT, {
            detail: $filter.dataset.filter
        }));
    }

    setFilterByValue(value) {
        const $filter = Array.from(this.$filters).find($filter => $filter.dataset.filter === value);

        if (!$filter) {
            return;
        }

        this.setFilter($filter);
    }
}